import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './metaCombustivelModeloForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';

import { 
	getListaLog as getLista
} from './metaCombustivelModeloActions';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import consts from '../consts';
import ContentCardFooter from '../common/template/contentCardFooter';

class MetaCombustivelModeloConsultaLog extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		data_inicial: DateFormat.getDataAnterior(10),
		data_final: DateFormat.getDataAtual(),
		ordenacao: {
			datahora_inclusao: 1
		}
	}

    componentWillMount() {
        this.props.getLista(this.state.data_inicial, this.state.data_final);
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />
					
					{this.lista()}					
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	lista() {

		let lista = this.props.lista.filter(item => {

			return !(this.state.pesquisar || '').trim()
				|| (this.state.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_consulta)}
					${item.nome_usuario}
					${item.placa}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			

			
		});

		if (this.state.ordenacao.datahora_inclusao) {
			lista.sort((a, b) => this.state.ordenacao.datahora_inclusao == 1 
				? (a.datahora_inclusao > b.datahora_inclusao ? 1 : -1) 
				: (a.datahora_inclusao > b.datahora_inclusao ? -1 : 1));
		} else if (this.state.ordenacao.nome_usuario) {
			lista.sort((a, b) => this.state.ordenacao.nome_usuario == 1 
				? (a.nome_usuario > b.nome_usuario ? 1 : -1) 
				: (a.nome_usuario > b.nome_usuario ? -1 : 1));
		} else if (this.state.ordenacao.placa) {
			lista.sort((a, b) => this.state.ordenacao.placa == 1 
				? (a.placa > b.placa ? 1 : -1) 
				: (a.placa > b.placa ? -1 : 1));
		}

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.state.pesquisar}
							onChange={value => {
								this.setState({ ...this.state, pesquisar: value });
							}} />

						<LabelAndInputDate
							label='Período Inicial'
							cols='12 6 4 4'
							value={this.state.data_inicial}
							onChange={value => {
								this.setState({ ...this.state, data_inicial: value });
							}} />

						<LabelAndInputDate
							label='Período Final'
							cols='12 6 4 4'
							value={this.state.data_final}
							onChange={value => {
								this.setState({ ...this.state, data_final: value });
							}} />

						<div style={{ width: 100, marginTop: 8, marginLeft: 8 }}>						
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista(this.state.data_inicial, this.state.data_final);
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
						</div>
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 190}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 190}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)
						}}>
						<Table responsive border striped alturaFixa 
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 190}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 190}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { datahora_consulta: this.getNovaOrdenacao(this.state.ordenacao.datahora_consulta) }})} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Data/Hora {this.getIconeOrdenacao(this.state.ordenacao.datahora_consulta)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_usuario: this.getNovaOrdenacao(this.state.ordenacao.nome_usuario) }})} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Usuário {this.getIconeOrdenacao(this.state.ordenacao.nome_usuario)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { placa: this.getNovaOrdenacao(this.state.ordenacao.placa) }})} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Placa {this.getIconeOrdenacao(this.state.ordenacao.placa)}</Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map((item, i) => {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td minWidth={100} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_consulta)}</Td>
											<Td minWidth={100} color={'#000'} alignCenter small>{item.nome_usuario}</Td>
											<Td minWidth={100} color={'#000'} alignCenter small>{item.placa}</Td>
										</Tr>
									);
								})}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.metaCombustivelModelo.aguardando,
	modoTela: state.metaCombustivelModelo.modoTela,
	lista: state.metaCombustivelModelo.listaLog
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaCombustivelModeloConsultaLog);
